const Blockly = require('blockly');

let menusAdded = false;
module.exports = function addWorkspaceMenuOptions({ dispatch } = {}) {
    //https://developers.google.com/blockly/guides/configure/web/context-menus
    if (menusAdded) return;
    try {
        if (Blockly.ContextMenuRegistry.registry.getItem('blockComment')) {
            Blockly.ContextMenuRegistry.registry.unregister('blockComment');
        }
        if (Blockly.ContextMenuRegistry.registry.getItem('blockInline')) {
            Blockly.ContextMenuRegistry.registry.unregister('blockInline');
        }

        // // ===== EXPORT Blockly ====
        // //For debugging
        // const exportWorkspace = {
        //     displayText: 'Export Workspace',
        //     preconditionFn: function ({ workspace }) {
        //         if (workspace.getTopBlocks().length) {
        //             return 'enabled';
        //         }
        //         return 'disabled';
        //     },
        //     callback: function ({ workspace }) {
        //         //https://developers.google.com/blockly/guides/configure/web/serialization
        //         const blocklyAsJson = Blockly.serialization.workspaces.save(workspace);
        //         console.log(JSON.stringify(blocklyAsJson, null, 2));
        //         debugger;
        //     },
        //     scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
        //     id: 'exportWorkspace',
        //     weight: 100
        // };
        // Blockly.ContextMenuRegistry.registry.register(exportWorkspace);

        // // ===== Export Metadata ===
        // //for debugging
        // const exportMetadata = {
        //     displayText: 'Export Metadata',
        //     preconditionFn: function ({ workspace }) {
        //         if (workspace.getTopBlocks().length) {
        //             return 'enabled';
        //         }
        //         return 'disabled';
        //     },
        //     callback: function ({ workspace }) {
        //         //https://developers.google.com/blockly/guides/configure/web/serialization
        //         const metadata = Blockly.JavaScript.workspaceToCode(workspace);
        //         console.log(JSON.stringify(metadata, null, 2));
        //         debugger;
        //     },
        //     scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
        //     id: 'exportMetadata',
        //     weight: 100
        // };
        // Blockly.ContextMenuRegistry.registry.register(exportMetadata);

        // ==== FOCUS HERE =====
        Blockly.ContextMenuRegistry.registry.register({
            displayText: 'Focus Here',
            preconditionFn: () => 'enabled',
            callback: ({ block }) => {
                focusBlock(block);
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: 'focusOnBlock',
            weight: 100
        });

        Blockly.ContextMenuRegistry.registry.register({
            displayText: 'Details',
            preconditionFn: ({ block, workspace }) => {
                if (!dispatch) {
                    return 'disabled';
                }
                if (block.type === 'form_Form') {
                    return 'enabled';
                }
                //For now, only for top blocks
                const topBlock0 = workspace.getTopBlocks(true)[0];
                if (parent.id !== topBlock0.id) {
                    return 'disabled';
                }
                return 'enabled';
            },
            callback: ({ block, workspace }) => {
                const topBlock = workspace.getTopBlocks(true)[0];
                const pageId = topBlock.id;
                dispatch(
                    { pageId, blockId: block.id },
                    { verb: 'edit', namespace: 'metadata', relation: 'blockDetail' }
                );
            },
            scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
            id: 'openDetails',
            weight: 100
        });

        //double click support
        Blockly.Extensions.register('collapse_on_double_click', function() {
            this.setOnChange(function({ type: eventType, blockId }) {
                if (eventType === Blockly.Events.CLICK && blockId === this.id) {
                    this.clickedCount = this.clickedCount || 0;
                    this.clickedCount++;
                    if (this.clickedCount >= 2) {
                        this.setCollapsed(!this.isCollapsed());
                    }
                    setTimeout(() => {
                        this.clickedCount = 0;
                    }, 300);
                }
            });
        });

        // This is the right-click context menu.
        menusAdded = true;
    } catch (error) {
        Blockly.ContextMenuRegistry.registry.reset();
        menusAdded = false;
    }
};

function focusBlock(block) {
    expandToTop(block);
    // Might need to expand all parents.
    block.select(); // *block* is the block to scroll into view.
    let xy = block.getRelativeToSurfaceXY();
    //blocks report coordinates in pixels, workspace uses scaled values
    xy = {
        x: xy.x * block.workspace.scale,
        y: xy.y * block.workspace.scale
    };
    let m = block.workspace.getMetrics();
    //first, we need to align the scroll area with the view area
    //The user can move both the canvas, and the scrollbars independently
    //we only update the scrollbar.
    //Confusingly, the moved canvas is reported using scroll*,
    //while if we set the scrollbar, it updates the view* values
    let newX = -m.scrollLeft;
    let newY = -m.scrollTop;
    //then we want to move more to put the block in the top left corner,
    //and then move a little back to have some margin around our block
    newX = newX + xy.x - 100;
    newY = newY + xy.y - 70;
    block.workspace.scrollbar.set(newX, newY);
}

function expandToTop(block) {
    if (block.isCollapsed) {
        block.setCollapsed(false);
    }
    let parent = block.getSurroundParent();
    if (parent) {
        expandToTop(parent);
    }
}
